import { ReceiptText } from 'lucide-react'
import Box from '@/common/components/Box'
import { ManualEntryProposalShowData } from '../../../types/maintenanceManualEntryProposal.type'
import ProposalObjectives from '../../ProposalObjectives'

type Props = {
  proposal: ManualEntryProposalShowData
}

const ExecutionDiagnosticSection = ({ proposal }: Props) => {
  const objectives = proposal.manual_entry?.forwarding?.directive_entry?.objectives ?? []

  if (proposal.status === 'completed' || objectives.length === 0) {
    return null
  }

  return (
    <Box className="p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <ReceiptText className="size-4 text-white-400" strokeWidth={1.5} />
        <p className="text-sm font-medium">Objetos do diagnóstico</p>
      </div>

      <ProposalObjectives objectives={objectives} content={null} />
    </Box>
  )
}

export default ExecutionDiagnosticSection
